import OImage from 'components/reusable/OImage'
import { startCase } from 'lodash'
import React from 'react'
import { useTranslation } from 'react-i18next'
import helper from 'utils/helpers'
import userAvatar from '../../../assets/images/userAvatar.png'

const AgentDetailViewPage = ({ item }) => {
  const { t } = useTranslation()

  return (
    <>
      <div className='relative p-6 flex-auto'>
        <div className=' border-2 rounded-md p-5'>
          <div className='grid grid-cols-4 '>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_FULL_NAME')}:</strong>
              </div>
              {startCase(item?.firstName + ' ' + item?.lastName)}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_COUNTRY_CODE')}:</strong>
              </div>
              {item?.countryCode}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_MOBILE_NUMBER')}:</strong>
              </div>
              {item?.mobile}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_EMAIL_ADDRESS')}:</strong>
              </div>
              {item?.email || 'N/A'}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_DESIGNATION')}:</strong>
              </div>
              {startCase(item?.designation)}
            </div>

            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_BRN_NUMBER')}:</strong>
              </div>
              {item?.brn || 'N/A'}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('NATIONALITY')}:</strong>
              </div>
              {startCase(item?.nationality) || 'N/A'}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_LANGUAGE')}:</strong>
              </div>
              {item?.language}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_CREATED_AT')}:</strong>
              </div>
              {helper.dateFormat(item?.createdAt)}{' '}
            </div>

            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_ACTIVE_DE_ACTIVE')}:</strong>
              </div>
              {startCase(item?.status) || 'N/A'}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_PROFILE_PICTURE')}:</strong>
                <figure className='w-24 h-24'>
                  {/* <img src={item?.profilePic} alt='' /> */}
                  <OImage
                    src={item?.profilePic ?? userAvatar}
                    fallbackUrl={userAvatar}
                    className='w-full h-full bg-cover'
                    alt=''
                  />
                  {/* <img src="https://www.kindpng.com/picc/m/729-7293951_small-house-png-image-home-png-transparent-png.png" alt=''/> */}
                </figure>
              </div>
            </div>
          </div>
          <div className='mb-3'>
            <div className=''>
              <strong>{t('Bio')}:</strong>
            </div>
            {item?.bio || 'N/A'}
          </div>
        </div>
      </div>
    </>
  )
}

export default AgentDetailViewPage
